import {
  ACTION_RESULT_TYPE,
  ARTICLE_TYPE,
  BANNER_TYPE,
  BUTTON_TYPE,
  CALENDAR_EVENT_TYPE,
  NOTIFICATION_TYPE,
  PURCHASE_RESULT_TYPE,
  SHOW_TYPE,
} from '@esentai/core/features/campaigns/consts/types';
import {
  Step,
  StepLabel,
  Stepper,
  Typography,
  withStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Breadcrumbs, { Breadcrumb } from '@/components/Breadcrumbs';
import { NotFound } from '@/components/ErrorMessages';
import FormSection from '@/components/FormSection';
import Page from '@/components/Page';
import PageContent from '@/components/PageContent';
import PageHeader from '@/components/PageHeader';
import PageTitle from '@/components/PageTitle';
import PaperSheet from '@/components/PaperSheet';
import { ROUTE_PATH as CAMPAIGNS_PATH } from '@/features/campaignsPage/consts';

import FirstStep from './FirstStep';
import InitialStep from './InitialStep';
import NonEditableMessage from './NonEditableMessage';
import SecondStepActionResult from './SecondStepActionResult';
import SecondStepArticle from './SecondStepArticle';
import SecondStepBanner from './SecondStepBanner';
import SecondStepButton from './SecondStepButton';
import SecondStepCalendarEvent from './SecondStepCalendarEvent';
import SecondStepNotification from './SecondStepNotification';
import SecondStepPurchaseResult from './SecondStepPurchaseResult';
import SecondStepShow from './SecondStepShow';
import styles from './styles';
import ThirdStep from './ThirdStep';

const steps = [
  {
    title: 'Шаг 1: Опишите кампанию',
    description:
      'Заполните информацию о характере кампании, продолжительности и особенностях',
  },
  {
    title: 'Шаг 2: Настройте кампанию',
    description: 'Наполните кампанию контентом и укажите ее характеристики.',
  },
  {
    title: 'Шаг 3: Сформируйте сегмент',
    description:
      'Укажите фильтры для формирования сегмента аудитории и его свойства.',
  },
];

const typeMapping = {
  [ACTION_RESULT_TYPE]: SecondStepActionResult,
  [BANNER_TYPE]: SecondStepBanner,
  [BUTTON_TYPE]: SecondStepButton,
  [ARTICLE_TYPE]: SecondStepArticle,
  [CALENDAR_EVENT_TYPE]: SecondStepCalendarEvent,
  [NOTIFICATION_TYPE]: SecondStepNotification,
  [SHOW_TYPE]: SecondStepShow,
  [PURCHASE_RESULT_TYPE]: SecondStepPurchaseResult,
};

class EditCampaign extends Component {
  static propTypes = {
    isEditable: PropTypes.bool.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    match: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
  };

  getStep = () => {
    const { match } = this.props;
    const { params } = match;
    const { step } = params || {};

    if (step) {
      return Number(step) - 1;
    }

    return null;
  };

  getActiveStep = () => {
    const step = this.getStep();

    return step || 0;
  };

  render() {
    const { classes, isEditable, isLoaded } = this.props;
    const activeStep = this.getActiveStep();

    if (!steps[activeStep]) {
      return <NotFound />;
    }

    if (!isLoaded) {
      return null;
    }

    if (!isEditable) {
      return <NonEditableMessage />;
    }

    return (
      <Page>
        <PageHeader gutterBottom={false}>
          <Breadcrumbs>
            <Breadcrumb to={CAMPAIGNS_PATH}>Кампании</Breadcrumb>
          </Breadcrumbs>
          <PageTitle>Создание кампании</PageTitle>
          <Stepper
            activeStep={activeStep}
            nonLinear
            classes={{ root: classes.stepperRoot }}
          >
            {steps.map(({ title, description }) => (
              <Step key={title} classes={{ root: classes.step }}>
                <StepLabel
                  optional={
                    <Typography variant="caption">{description}</Typography>
                  }
                  classes={{ label: classes.stepLabel }}
                >
                  {title}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </PageHeader>
        <PageContent>
          <FormSection className={classes.pageTitle}>
            <Typography variant="h4" color="inherit" gutterBottom>
              {this.renderStepTitle()}
            </Typography>
          </FormSection>
          <PaperSheet className={classes.paper}>
            {this.renderActiveStep()}
          </PaperSheet>
        </PageContent>
      </Page>
    );
  }

  renderActiveStep() {
    const activeStep = this.getStep();

    if (activeStep === 0) {
      return <FirstStep isEdit />;
    } else if (activeStep === 1) {
      return this.getStepByType();
    } else if (activeStep === 2) {
      return <ThirdStep />;
    } else if (activeStep === null) {
      return <InitialStep />;
    }

    return null;
  }

  renderStepTitle() {
    const activeStep = this.getActiveStep();
    const currentStep = steps[activeStep];

    return currentStep.title;
  }

  getStepByType() {
    const { type } = this.props;
    const TargetStep = typeMapping[type];

    return <TargetStep />;
  }
}

export default withStyles(styles)(EditCampaign);
